import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Row,
  message,
  Col,
  Spin,
} from 'antd';
import MaskedTextInput from 'react-text-mask';
import { useQuery, useMutation } from '@apollo/client';
import { BUSINESS_USER } from 'services/graphql/queries';
import { SAVE_BUSINESS_USER } from 'services/graphql/mutations';
import { Images } from 'assets';
import { formatError } from 'utils';

const { Item, useForm } = Form;
const { LogoGyraG } = Images;

const PhoneNumberForm = ({
  id,
  onCompleted,
  goBack,
}) => {
  const [form] = useForm();
  const {
    data: { businessUser: { user: { fullName, phoneNumberVerified } = {} } = {} } = {},
    loading,
  } = useQuery(BUSINESS_USER, {
    skip: !id,
    variables: { id },
    partialRefetch: true,
    fetchPolicy: 'network-only',
    onCompleted: ({ businessUser: { user: { phoneNumber } } = {} } = {}) => {
      form.setFieldsValue({
        phoneNumber,
      });
    },
  });
  const [saveBusinessUser, { loading: saveLoading }] = useMutation(SAVE_BUSINESS_USER, {
    onCompleted: () => onCompleted(),
    onError: (error) => message.error(formatError(error)),
  });
  const onFinish = async (values) => {
    await form.validateFields();
    saveBusinessUser({
      variables: {
        id,
        ...values,
      },
    });
  };
  return (
    <Spin
      indicator={<LogoGyraG className="rotating" style={{ width: 64, height: 64 }} />}
      spinning={loading}
      style={{ transform: 'translateX(-16px)' }}
    >
      <Form
        form={form}
        onFinish={onFinish}
      >
        <h3 className="wl-text" style={{ marginBottom: 24 }}>
          {`Insira o celular de ${fullName}`}
        </h3>
        <Item name="phoneNumber" rules={[{ required: true, message: 'Por favor preencha o celular.' }]}>
          <MaskedTextInput
            className="ant-input"
            disabled={phoneNumberVerified}
            guide
            mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholder="Telefone com DDD"
          />
        </Item>
        <Row gutter={12} className="fixed-footer">
          <Col span={10}>
            <Button
              block
              disabled={saveLoading}
              ghost
              type="primary"
              onClick={() => goBack()}
            >
              Voltar
            </Button>
          </Col>
          <Col span={14}>
            <Button
              id="business-user-phoneNumber-continue"
              block
              loading={saveLoading}
              type="primary"
              htmlType="submit"
            >
              Continuar
            </Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

PhoneNumberForm.propTypes = {
  id: PropTypes.string,
  onCompleted: PropTypes.func,
  goBack: PropTypes.func,
};

export default memo(PhoneNumberForm);
